import React from 'react';

import PropTypes from 'prop-types';

import { jsUcFirst } from 'modules/common/utils';

const renderItem = (label, value) => (
  <div className="space-y-1.5">
    <h4 className="font-semibold text-gray-400 text-xs">{label}</h4>
    <div className="text-sm">{value}</div>
  </div>
);

function InformationCard({ data }) {
  const {
    branch_name,
    customer_name,
    merchant_name,
    branch_mobile_number,
    customer_email_address,
    customer_contact_number,
  } = data;

  return (
    <div className="card">
      <h4 className="font-semibold">Information</h4>
      <div className="grid grid-cols-1 gap-4 mt-3">
        {data?.transaction_type !== 'POS'
          ? renderItem(
              'CUSTOMER',
              <div className="space-y-1">
                <span className="font-semibold text-primary-500 border-b border-primary-500 border-dashed">
                  {jsUcFirst(customer_name, '--')}
                </span>
                <div className="text-gray-400 text-sm flex flex-col mt-1">
                  <span>+{customer_contact_number}</span>
                  <span>{customer_email_address}</span>
                </div>
              </div>
            )
          : null}

        {renderItem(
          'BRANCH NAME',
          <div className="space-y-1">
            <span className="font-semibold text-primary-500 border-b border-primary-500 border-dashed">
              {merchant_name} - {jsUcFirst(branch_name)}
            </span>
            <div className="text-gray-400 text-sm flex flex-col mt-1">
              <span>+{branch_mobile_number}</span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
InformationCard.defaultProps = {
  data: {},
};

InformationCard.propTypes = {
  data: PropTypes.instanceOf(Object),
};

export default InformationCard;
